import { isEmpty } from 'src/utils/isEmpty'
import {
  useChoiceDispatch,
  useChoiceState,
  setPreferredPractitioners,
  resetSelectedBookable,
  setAllPractitionersAreSelected,
} from '@context/ChoiceContext'
import {
  usePractitionersDispatch,
  setSelectedPractitionersFor,
  resetSelectedPractitionersFor,
  usePractitionersContext,
} from '@context/PractitionersContext'

interface UseSelectPreferredPractitionerParams {
  clearSelectedSlot: boolean
  possibleToSetAll: boolean
}

export const useSelectPreferredPractitioner = ({
  clearSelectedSlot,
  possibleToSetAll,
}: UseSelectPreferredPractitionerParams) => {
  const choiceDispatch = useChoiceDispatch()
  const practitionersDispatch = usePractitionersDispatch()
  const { allPractitioners } = usePractitionersContext()
  const { treatmentBundleTypeReferenceId, patientType } = useChoiceState()

  return (selectedPractitionerIds: Array<string | undefined>, patientReferenceId?: string) => {
    const preferredPractitionerIds = selectedPractitionerIds.filter((item): item is string => typeof item === 'string')

    choiceDispatch(setPreferredPractitioners(preferredPractitionerIds))

    const allPractitionersAreSelected = preferredPractitionerIds.length === allPractitioners.length

    if (possibleToSetAll) {
      choiceDispatch(setAllPractitionersAreSelected(allPractitionersAreSelected))
    } else {
      choiceDispatch(setAllPractitionersAreSelected(false))
    }

    if (clearSelectedSlot) {
      choiceDispatch(resetSelectedBookable())
    }

    if (isEmpty(preferredPractitionerIds)) {
      practitionersDispatch(resetSelectedPractitionersFor())
    } else {
      practitionersDispatch(
        setSelectedPractitionersFor({
          treatmentReferenceId: treatmentBundleTypeReferenceId || '',
          patientType,
          patientReferenceId: patientReferenceId || '',
        })
      )
    }
  }
}
